export var initialCarpoolState = {
    licensePlate: '',
    groupId: '',
    groupOwnerAlias: '',
    id: '',
    carpoolMembers: [
        {
            memberType: '',
            memberAlias: '',
            originCity: '',
            permitNumber: '',
            email: '',
        },
    ],
    carpoolPolicyChecked: false,
};
export var initialIsCarpoolErrorState = {
    isCarpoolError: false,
};
